import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

function ProductSmokingHero() {
  return (
    <Container
      component="section"
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 9 }}
    >
      <Button
        sx={{
          border: '4px solid currentColor',
          borderRadius: 0,
          height: 'auto',
          py: 2,
          px: 5,
        }}
      >
        <Typography variant="h4" component="span">
          Got any questions? Need help?
        </Typography>
      </Button>
      <Typography variant="subtitle1" sx={{ my: 3 }}>
        We are here to help. 
        <a href="mailto:support@developerbox.ca">Get in touch!</a>
      </Typography>
      <Box
        sx={{ width: 60 }}
      >
        <SupportAgentIcon />
      </Box>
    </Container>
  );
}

export default ProductSmokingHero;
